export const en = {
  'common.liveSignals': 'Live signals',
  'common.coo': 'COO',
  'count.members_one': '{{count, number}} member',
  'count.members_other': '{{count, number}} members',
  'count.issues_one': '{{count, number}} issue detected',
  'count.issues_other': '{{count, number}} issues detected',
  'count.uploaded_one': '{{count, number}} additional file uploaded',
  'count.uploaded_other': '{{count, number}} additional files uploaded',
  'common.thisSubject': 'this subject',
  'common.unavailable': 'not available',

  'count.organizations': '{{count, number}} organizations found',
  'count.officers': '{{count, number}} officers found',
  'count.informational': '{{count, number}} informational',
  'common.viewer': 'Viewer',
  'common.selectDate': 'Select a date',

  'count.selected': '{{count, number}} of {{total, number}} rows selected.',
  'count.results_one': 'Showing {{count, number}} result.',
  'count.results_other': 'Showing {{count, number}} results.',
  'count.owners_one': '{{count, number}} owner found',
  'count.owners_other': '{{count, number}} owners found',
  'count.reports_one': '{{count, number}} report found',
  'count.reports_other': '{{count, number}} reports found',
  'count.clients_one': '{{count, number}} client found',
  'count.clients_other': '{{count, number}} clients found',
  'count.page': 'Page {{page, number}} of {{total, number}}',
  'count.member': 'Member {{count, number}}',
  'common.reportType': '{{type}} report',
  'common.previousPeriod': '{{value, number}}% from previous period',
  'common.recipient': 'To:',
  'common.deleteConfirmation': "You must enter '{{value}}' to proceed",
  'common.removeFilter': 'Remove {{label}} filter',
  'invitation.subject': 'Invitation to join Raven',
  'invitation.ownerBody':
    'You have been invited to join {{organization}} as an owner on Raven. Use the activation link in your invitation email to set up your account.',
  'invitation.officerBody':
    'You have been invited to join Raven as {{role}}. Use the activation link in your invitation email to set up your account.',
} as const;
export const fa: Record<keyof typeof en, string> = {
  'common.liveSignals': 'یافته‌های لحظه‌ای',
  'common.coo': 'مدیر عملیات',
  'count.members_one': '{{count, number}} عضو',
  'count.members_other': '{{count, number}} عضو',
  'count.issues_one': '{{count, number}} مورد شناسایی شد',
  'count.issues_other': '{{count, number}} مورد شناسایی شد',
  'count.uploaded_one': '{{count, number}} فایل تکمیلی بارگذاری شد',
  'count.uploaded_other': '{{count, number}} فایل تکمیلی بارگذاری شد',
  'common.thisSubject': 'این شخص یا شرکت',
  'common.unavailable': 'در دسترس نیست',

  'count.organizations': '{{count, number}} سازمان پیدا شد',
  'count.officers': '{{count, number}} کارشناس پیدا شد',
  'count.informational': '{{count, number}} مورد جهت اطلاع',
  'common.viewer': 'مشاهده‌گر',
  'common.selectDate': 'انتخاب تاریخ',

  'count.selected': '{{count, number}} ردیف از {{total, number}} ردیف انتخاب شده است.',
  'count.results_one': 'نمایش {{count, number}} نتیجه',
  'count.results_other': 'نمایش {{count, number}} نتیجه',
  'count.owners_one': '{{count, number}} مالک پیدا شد',
  'count.owners_other': '{{count, number}} مالک پیدا شد',
  'count.reports_one': '{{count, number}} گزارش پیدا شد',
  'count.reports_other': '{{count, number}} گزارش پیدا شد',
  'count.clients_one': '{{count, number}} مشتری پیدا شد',
  'count.clients_other': '{{count, number}} مشتری پیدا شد',
  'count.page': 'صفحه {{page, number}} از {{total, number}}',
  'count.member': 'عضو {{count, number}}',
  'common.reportType': 'گزارش {{type}}',
  'common.previousPeriod': '{{value, number}}٪ نسبت به دوره قبل',
  'common.recipient': 'گیرنده:',
  'common.deleteConfirmation': 'برای ادامه «{{value}}» را وارد کنید',
  'common.removeFilter': 'حذف فیلتر {{label}}',
  'invitation.subject': 'دعوت به عضویت در Raven',
  'invitation.ownerBody':
    'شما به‌عنوان مالک به {{organization}} در Raven دعوت شده‌اید. برای فعال‌سازی حساب، از لینک موجود در ایمیل دعوت استفاده کنید.',
  'invitation.officerBody':
    'شما با نقش {{role}} به Raven دعوت شده‌اید. برای فعال‌سازی حساب، از لینک موجود در ایمیل دعوت استفاده کنید.',
};
